import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Typography,
  Box,
  InputAdornment,
  Snackbar,
  Alert,
} from "@mui/material";
import { registerUser } from "../Api/registerUser"; // Assuming the registerUser function is in an api.js file
import { emailOtp } from "../Api/sendOtp";

function SignUpModal({ open, onClose, onOpenLogin, onSuccessfulLogin }) {
  const [userName, setuserName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [otp, setOtp] = useState("");
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [cooldown, setCooldown] = useState(0);
  const[userdata,setUserData]=useState(""); 
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const handleSignUp = async () => {
    if (password !== confirmPassword) {
      setPasswordError("Passwords do not match");
      return;
    }

    // Create a plain object instead of FormData
    const user = {
      userName: userName,
      email: email,
      password: password,
      otp: otp,
    };

    try {
      // Send the userData object instead of FormData
      const result = await registerUser(user);
      const accessToken = result.data.token; // Replace `token` with the actual key from the API response
      const userData = result.data.User; 
      setUserData(JSON.stringify(userData));
      localStorage.setItem("userdata",JSON.stringify(userData));
      // localStorage.setItem("userName", result.data.email);
      console.log("result", result.data);
      console.log("user", result.data.User);
      localStorage.setItem("userId", result.data.User._id);
      console.log("userId", result.data.User._id);
      if (accessToken) {
        localStorage.setItem("accessToken", accessToken);
      }
      setSnackbar({
        open: true,
        message: "Registration successful!",
        severity: "success",
      });
      onSuccessfulLogin("/placeholder.svg?height=40&width=40"); // Pass profile image as a placeholder
      onClose();
      setuserName("");
      setEmail("");
      setPassword("");
      setConfirmPassword("");
      setOtp("");
      setIsOtpSent(false);
    } catch (error) {
      console.error("Registration failed:", error);
      setSnackbar({
        open: true,
        message: error.message || "Registration failed",
        severity: "error",
      });
    }
  };

  const handleLoginClick = () => {
    onClose();
    onOpenLogin();
  };

  const validateEmail = (email) => {
    const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return re.test(String(email).toLowerCase());
  };

  const handleEmailChange = (e) => {
    const newEmail = e.target.value;
    setEmail(newEmail);
  
    // Show error only if the email contains '@' and user has typed more than 5 characters
    if (newEmail.includes("@") || newEmail.length < 5) {
      setEmailError(""); // Clear error while typing
    } else {
      setEmailError("Please enter a valid email address");
    }
  };
  
  
  
  const handlePasswordChange = (e) => {
    const newPassword = e.target.value;
    setPassword(newPassword);
  
    // Show error only if user has typed at least 3 characters but less than 8
    if (newPassword.length >= 3 && newPassword.length < 6) {
      setPasswordError("Password must be at least 8 characters");
    } else {
      setPasswordError(""); // Clear error if password is valid
    }
  };
  

  const handleConfirmPasswordChange = (e) => {
    const newConfirmPassword = e.target.value;
    setConfirmPassword(newConfirmPassword);
    if (newConfirmPassword && newConfirmPassword !== password) {
      setPasswordError("Passwords do not match");
    } else {
      setPasswordError("");
    }
  };

  const handleSendOtp = async () => {
    if (!validateEmail(email)) {
      setEmailError("Please enter a valid email address");
      return;
    }
  
    // Show Snackbar immediately before API call
    setSnackbar({
      open: true,
      message: "Sending OTP...",
      severity: "info", // Change to 'info' while sending
    });
  
    try {
      const sendOtp = { email };
      await emailOtp(sendOtp); // Wait for the API call
      console.log("OTP sent to:", email);
      setIsOtpSent(true);
      setCooldown(30);
  
      // Update Snackbar after successful OTP send
      setSnackbar({
        open: true,
        message: "OTP sent successfully!",
        severity: "success",
      });
    } catch (error) {
      console.error("OTP sending failed:", error);
      setSnackbar({
        open: true,
        message: "Failed to send OTP. Try again!",
        severity: "error",
      });
    }
  };
  

  const handleOtpChange = (e) => {
    const newOtp = e.target.value.replace(/[^0-9]/g, "").slice(0, 6);
    setOtp(newOtp);
  };

  useEffect(() => {
    let timer;
    if (cooldown > 0) {
      timer = setInterval(() => {
        setCooldown((prevCooldown) => prevCooldown - 1);
      }, 1000);
    }
    return () => {
      if (timer) clearInterval(timer);
    };
  }, [cooldown]);

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbar({ ...snackbar, open: false });
  };

  return (
    <>
      <Dialog open={open} onClose={onClose}>
        <DialogTitle>Sign Up</DialogTitle>
        <DialogContent>
        {snackbar.open && (
          <Snackbar
            open={snackbar.open}
            autoHideDuration={6000}
            onClose={handleCloseSnackbar}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            sx={{ position: "absolute", top: 0, left: "50%", transform: "translateX(-50%)" }}
          >
            <Alert
              onClose={handleCloseSnackbar}
              severity={snackbar.severity}
              sx={{ width: "100%" }}
            >
              {snackbar.message}
            </Alert>
          </Snackbar>
        )}
          <TextField
            autoFocus
            margin="dense"
            label="userName"
            type="text"
            fullWidth
            value={userName}
            onChange={(e) => setuserName(e.target.value)}
          />
          <Box sx={{ display: "flex", alignItems: "flex-start", mt: 2 }}>
            <TextField
              margin="dense"
              label="Email Address"
              type="email"
              fullWidth
              value={email}
              onChange={handleEmailChange}
              error={!!emailError}
              helperText={emailError}
              sx={{ mr: 1 }}
            />
            <Button
              variant="contained"
              onClick={handleSendOtp}
              disabled={!email || !!emailError || cooldown > 0}
              sx={{ mt: 1 }}
            >
              {cooldown > 0 ? `Resend OTP (${cooldown}s)` : "Send OTP"}
            </Button>
          </Box>
          <TextField
            margin="dense"
            label="Password"
            type="password"
            fullWidth
            value={password}
            onChange={handlePasswordChange}
            error={!!passwordError}
            helperText={passwordError}
          />
          <TextField
            margin="dense"
            label="Confirm Password"
            type="password"
            fullWidth
            value={confirmPassword}
            onChange={handleConfirmPasswordChange}
            error={!!passwordError}
            helperText={passwordError}
          />
          {isOtpSent && (
            <TextField
              margin="dense"
              label="Email OTP"
              type="text"
              fullWidth
              value={otp}
              onChange={handleOtpChange}
              InputProps={{
                inputMode: "numeric",
                pattern: "[0-9]*",
                maxLength: 6,
                endAdornment: (
                  <InputAdornment position="end">{otp.length}/6</InputAdornment>
                ),
              }}
            />
          )}
          <Typography variant="body2" sx={{ mt: 2 }}>
            Already have an account?
            <Button color="primary" onClick={handleLoginClick}>
              Login
            </Button>
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Cancel</Button>
          <Button
            onClick={handleSignUp}
            disabled={
              !isOtpSent ||
              otp.length !== 6 ||
              !userName ||
              !email ||
              !password ||
              password !== confirmPassword
            }
          >
            Sign Up
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default SignUpModal;
